module.exports = __webpack_public_path__ + "static/media/rug2.bd6259ea.jpg";